export const environment = {
  production: false,
  useMocks: false,
  // apiBaseUrl: 'https://api-legajostecnicosdev.espaciopampa.com/api',
  apiBaseUrl: 'https://app-ptq-dev-eastus-legajostecnicos-dvd2fre4bec4fucz.eastus-01.azurewebsites.net/api',

  clientId: 'a294c886-1a2e-4467-a7b2-98453b35eef6',
  tenantId: 'eef41338-8caf-4011-87bf-ff1c9c425f9e',
  redirectURL: 'https://legajostecnicosdev.espaciopampa.com/',
  
  // production: false,
  // useMocks: false,
  // apiBaseUrl: 'http://localhost:5275/api',

  // clientId: 'fb71f2fc-8b6c-409b-a4aa-23c56d931c84',
  // tenantId: 'eef41338-8caf-4011-87bf-ff1c9c425f9e',
  // redirectURL: 'http://localhost:4200/',
};
